import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Porta } from "app/models/porta";
import { PortaDivisaoArea } from "app/pages/full-pages/equipamento/porta/models/porta-divisao-area";
import { Observable } from "rxjs";

export abstract class AbPortaDivisaArea extends AppService {
  abstract prefixo: string;
  abstract perfilSelecionado: any;
  abstract desativar(id: number);
  abstract getAllPortas(filter: AppFilter);
  abstract getAllZonas(zonaId: number);
  abstract getPorta(id: number);
  abstract savePorta(porta: Porta): Observable<Porta>;
  abstract ListByDivisao(divisaoId: number);
  abstract getIdentificacaoPerfil(id: number, tipo: string);
  abstract ListByArea(areaId: number);
  abstract savePortaDivisaoArea(pda: PortaDivisaoArea);
  abstract getPortas(): Observable<any>;
  abstract getPerfis(): Observable<any>;
}